import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook'
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'gatsby'
import React from 'react'
import NewsletterForm from './NewsletterForm'

import ExternalLink from './ExternalLink'
import useSiteMetadata from '../hooks/use-site-metadata'
import useFeaturedTipsheets from '../hooks/use-featured-tipsheets'

const Footer = () => {
  const {
    social: { facebook, twitter, instagram, linkedin },
  } = useSiteMetadata()
  const tipsheets = useFeaturedTipsheets()

  return (
    <footer className="p-8 mt-8 bg-green-600 text-white">
      <div className="w-full max-w-screen-lg mx-auto">
        <div className="sm:flex mb-4">
          <div className="sm:w-1/4 h-auto">
            <ul className="list-reset leading-relaxed">
              <Link to={`/guides/`}>
                <li>Guides Conseils</li>
              </Link>
            </ul>
          </div>

          <div className="sm:w-1/4 h-auto">
            <div className="text-xl mb-2">Guides</div>
            <ul className="list-reset leading-relaxed px-2">
              {tipsheets.map(({ category, slug, title }) => (
                <Link
                  to={`/${category.slug}/${slug}/`}
                  key={`footer-benchmark-${slug}`}
                >
                  <li>{title}</li>
                </Link>
              ))}
            </ul>
          </div>

          <div className="sm:w-1/2 sm:mt-0 mt-8 h-auto">
            <div className="mb-8">
              <div className="text-xl mb-2">Newsletter</div>
              <p className="mb-4">
                Recevez les derniers articles et guides en vous inscrivant
                gratuitement à la Newsletter Planète Durable.
              </p>

              <NewsletterForm className='my-2' />
            </div>

            <div className="mb-4">
              <div className="text-xl mb-4">Contactez-Nous</div>
              <div className="mt-4 flex">
                <div className="flex justify-start items-center text-xl text-white">
                  {twitter && (
                    <ExternalLink
                      className="block flex items-center hover:text-gray-300 mr-5"
                      href={`https://twitter.com/${twitter}`}
                      target="_blank"
                      rel="noreferrer nofollow"
                    >
                      <FontAwesomeIcon icon={faTwitter} />
                    </ExternalLink>
                  )}

                  {facebook && (
                    <ExternalLink
                      className="block flex items-center hover:text-gray-300 mr-5"
                      href={`https://www.facebook.com/${facebook}`}
                    >
                      <FontAwesomeIcon icon={faFacebook} />
                    </ExternalLink>
                  )}

                  {instagram && (
                    <ExternalLink
                      className="block flex items-center hover:text-gray-300 mr-5"
                      href={`https://www.instagram.com/${instagram}`}
                    >
                      <FontAwesomeIcon icon={faInstagram} />
                    </ExternalLink>
                  )}

                  {linkedin && (
                    <ExternalLink
                      className="block flex items-center hover:text-gray-300 mr-5"
                      href={`https://www.linkedin.com/company/${linkedin}`}
                    >
                      <FontAwesomeIcon icon={faLinkedin} />
                    </ExternalLink>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-screen-lg mx-auto text-sm text-center">
        <Link to={`/mentions-legales/`} rel="nofollow">
          Mentions Légales
        </Link>
      </div>
    </footer>
  )
}

export default Footer
